export enum PartyActions {
  confirmDelete = 'confirmDelete',
  addEditReservation = 'addEditReservation',
  chatParty = 'chatParty',
  cancel = 'cancel',
  checkIn = 'checkIn',
  completeParty = 'completeParty',
  serveParty = 'serveParty',
}
